import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PRICING_POINTS = [
  "Start free with test credits",
  "Pay-as-you-go bulk list cleaning",
  "Scale plans with SLAs and SSO available",
];

export default function PricingTeaserSection() {
    const navigate = useNavigate()
    const handlePricing = () => {
    navigate("/pricing");
    }
  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-sky-50 via-blue-50 to-indigo-50 dark:from-slate-900 dark:via-slate-900 dark:to-slate-900 border-y border-sky-200 dark:border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 dark:text-slate-50 mb-6">
            Simple, transparent pricing{" "}
            <span className="text-sky-600 dark:text-sky-400">
              for any volume
            </span>
          </h2>
          <p className="text-lg text-slate-600 dark:text-slate-300">
            No hidden fees, no complex tiers. Pay only for what you use, scale
            as you grow.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {PRICING_POINTS.map((point, index) => (
            <div
              key={index}
              className="bg-white dark:bg-slate-900 rounded-2xl p-6 border-2 border-slate-200 dark:border-slate-800 hover:border-sky-300 dark:hover:border-sky-700 transition-all hover:shadow-xl"
            >
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-sky-500 to-blue-600 flex items-center justify-center flex-shrink-0 shadow-md">
                  <Check className="h-5 w-5 text-white" />
                </div>
                <p className="text-slate-700 dark:text-slate-300 font-medium pt-1">
                  {point}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white dark:bg-slate-900 rounded-3xl p-8 md:p-12 border-2 border-slate-200 dark:border-slate-800 shadow-2xl">
          <div className="grid lg:grid-cols-4 gap-6 mb-8">
            <div className="text-center p-6 rounded-2xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700">
              <div className="text-2xl font-bold text-slate-900 dark:text-slate-50 mb-2">
                Starter
              </div>
              <div className="text-sm text-slate-600 dark:text-slate-400 mb-4">
                For small teams
              </div>
              <div className="text-3xl font-bold text-sky-600 dark:text-sky-400">
                Free
              </div>
              <div className="text-xs text-slate-500 dark:text-slate-400">
                100 credits/month
              </div>
            </div>

            <div className="text-center p-6 rounded-2xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700">
              <div className="text-2xl font-bold text-slate-900 dark:text-slate-50 mb-2">
                Growth
              </div>
              <div className="text-sm text-slate-600 dark:text-slate-400 mb-4">
                For growing teams
              </div>
              <div className="text-3xl font-bold text-sky-600 dark:text-sky-400">
                $49
              </div>
              <div className="text-xs text-slate-500 dark:text-slate-400">
                5K credits/month
              </div>
            </div>

            <div className="text-center p-6 rounded-2xl bg-gradient-to-br from-sky-50 to-blue-50 dark:from-sky-900/20 dark:to-blue-900/20 border-2 border-sky-300 dark:border-sky-700 relative">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-sky-600 text-white text-xs font-bold rounded-full">
                Popular
              </div>
              <div className="text-2xl font-bold text-slate-900 dark:text-slate-50 mb-2">
                Scale
              </div>
              <div className="text-sm text-slate-600 dark:text-slate-400 mb-4">
                For high-volume
              </div>
              <div className="text-3xl font-bold text-sky-600 dark:text-sky-400">
                $199
              </div>
              <div className="text-xs text-slate-500 dark:text-slate-400">
                25K credits/month
              </div>
            </div>

            <div className="text-center p-6 rounded-2xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700">
              <div className="text-2xl font-bold text-slate-900 dark:text-slate-50 mb-2">
                Enterprise
              </div>
              <div className="text-sm text-slate-600 dark:text-slate-400 mb-4">
                For organizations
              </div>
              <div className="text-3xl font-bold text-sky-600 dark:text-sky-400">
                Custom
              </div>
              <div className="text-xs text-slate-500 dark:text-slate-400">
                Unlimited credits
              </div>
            </div>
          </div>

          <div className="text-center">
            <button
            onClick={handlePricing}
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full text-base font-semibold bg-gradient-to-r from-sky-600 to-blue-600 text-white hover:from-sky-700 hover:to-blue-700 transition-all shadow-lg hover:shadow-xl hover:scale-105 transform duration-200 group">
              View pricing
              <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
